import * as React from "react";
import { useAnalyticsTrigger } from "../../helpers/analytics/use-analytics-trigger.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../helpers/helper/hooks/use-responsive-props.mjs";
import { InputContext } from "../../helpers/input-provider/input-provider.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const Selector = (props) => {
  const { responsive, ...rest } = props;
  const { input } = React.useContext(InputContext);
  const { onItemChange } = useAnalyticsTrigger({
    callback: "onItemChange",
    id: ([itemId, checked]) => "Selector - ".concat(checked ? "Check" : "Uncheck", " - ").concat(itemId),
    elementType: "selector",
    elementId: ([itemId]) => "".concat(itemId),
    interactionType: ([, checked]) => "".concat(checked ? "check" : "uncheck")
  });
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentName: "Selector", componentProps: rest, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" }, responsive ? /* @__PURE__ */ React.createElement(SelectorResponsive, { ...rest, responsive, inputIntent: input, onItemChange }) : /* @__PURE__ */ React.createElement(SelectorInner, { ...rest, inputIntent: input, onItemChange }));
};
const SelectorResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({
    responsive
  });
  return /* @__PURE__ */ React.createElement(SelectorInner, { ...rest, ...responsiveProps });
};
const _SelectorInner = class _SelectorInner extends React.Component {
  constructor(props) {
    super(props);
    this.inputsArray = [];
    this.setHoveredItemToState = (item) => {
      this.setState({
        hoveredItemValue: item.value
      });
    };
    this.removeHoveredItemFromState = () => {
      this.setState({
        hoveredItemValue: void 0
      });
    };
    this.onChange = (value, checked) => {
      let nextValue;
      if (this.props.inputType === "checkbox") {
        nextValue = Array.isArray(this.value) ? [...this.value] : [];
        if (checked) {
          nextValue.push(value);
        } else {
          nextValue = nextValue.filter((item) => item !== value);
        }
      } else {
        nextValue = value;
      }
      if (!this.isValueControlled()) {
        this.setState({
          value: nextValue
        });
      }
      if (this.props.onChange) {
        this.props.onChange(nextValue);
      }
    };
    this.state = {
      value: this.getInitialValue(props.defaultValue),
      hoveredItemValue: void 0
    };
  }
  get value() {
    return this.isValueControlled(this.props.value) ? this.props.value : this.state.value;
  }
  isValueControlled(value = this.props.value) {
    return !!this.props.onChange && typeof value !== "undefined";
  }
  getInitialValue(value) {
    if (value) {
      return value;
    } else if (this.props.inputType === "checkbox") {
      return [];
    } else {
      return "";
    }
  }
  BEM() {
    const classArray = ["selector"];
    if (this.props.size) {
      classArray.push("selector--" + this.props.size);
      if (this.props.size === "small" && this.props.labelSize) {
        classArray.push("selector--custom-label-size");
      }
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    if (this.props.hideLabel) {
      classArray.push("selector--hide-label");
    }
    if (this.props.align) {
      classArray.push("selector--" + this.props.align);
    }
    return classArray.join(" ");
  }
  getCheckedStatus(value) {
    if (this.props.inputType === "checkbox") {
      return value === this.value || this.value.indexOf(value) !== -1;
    } else {
      return value === this.value;
    }
  }
  getAriaDescribedBy() {
    const arr = [];
    if (this.props.helpMessage) {
      arr.push("".concat(this.props.id, "-help-message"));
    }
    if (this.props.errorMessage) {
      arr.push("".concat(this.props.id, "-error-message"));
    }
    if (this.props.successMessage) {
      arr.push("".concat(this.props.id, "-success-message"));
    }
    if (this.props.employeeMessage) {
      arr.push("".concat(this.props.id, "-employee-message"));
    }
    return arr.join(" ");
  }
  renderFormHelper() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.helpMessage, type: "help", className: "selector__form-helper", id: "".concat(this.props.id, "-help-message") }), this.props.errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.errorMessage, type: "error", className: "selector__form-helper", id: "".concat(this.props.id, "-error-message") }), this.props.successMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.successMessage, type: "valid", className: "selector__form-helper", id: "".concat(this.props.id, "-success-message") }), this.props.employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: this.props.employeeMessage, type: "employee", className: "selector__form-helper", id: "".concat(this.props.id, "-employee-message") }));
  }
  renderLabel(item) {
    const label = /* @__PURE__ */ React.createElement("span", { className: "selector__item-label" }, item.label);
    if (item.isInactive && !item.disabled) {
      return /* @__PURE__ */ React.createElement("del", { className: "selector__item-label-strikethrough" }, label);
    }
    return label;
  }
  mapItems() {
    const items = this.props.items.map((item, i) => {
      const itemStyles = {
        background: item.customColor
      };
      const checked = this.getCheckedStatus(item.value);
      const onChange = () => {
        const isChecked = this.inputsArray[i].checked;
        if (item.disabled) {
          return;
        }
        this.onChange(item.value, isChecked);
        if (item.onChange) {
          item.onChange(isChecked);
        }
        this.props.onItemChange(item.id, isChecked);
      };
      const classArray = ["selector__item"];
      const shouldAddEventListeners = this.props.inputIntent === "mouse" && this.props.showItemLabelNextToLabel;
      if (item.type) {
        classArray.push("selector__item--" + item.type);
      }
      if (item.customColor) {
        classArray.push("selector__item--custom-color");
      }
      if (item.isInactive) {
        classArray.push("selector__item--inactive");
      }
      if (item.className) {
        classArray.push(item.className);
      }
      const onClick = () => onChange();
      const renderIndicatorLabel = () => {
        if (item.children) {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { htmlFor: item.id, className: "selector__indicator-label--has-children" }, item.label), /* @__PURE__ */ React.createElement("div", { className: "selector__indicator", onClick }, /* @__PURE__ */ React.createElement("div", { className: "selector__indicator-inner" }, item.children)));
        }
        return /* @__PURE__ */ React.createElement("label", { htmlFor: item.id, className: "selector__indicator" }, /* @__PURE__ */ React.createElement("span", { className: "selector__indicator-inner", style: item.customColor ? itemStyles : void 0 }, this.renderLabel(item)));
      };
      return /* @__PURE__ */ React.createElement(GridColumn, { width: item.itemWidth || this.props.itemWidth, key: item.id, className: classArray.join(" ") }, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: item.id,
          ref: (el) => {
            if (el && !this.inputsArray.includes(el)) {
              this.inputsArray.push(el);
            }
          },
          value: item.value,
          name: item.name,
          disabled: item.disabled,
          checked,
          type: this.props.inputType,
          onChange,
          className: "selector__input",
          "aria-label": item.ariaLabel,
          "aria-invalid": !!this.props.errorMessage,
          "aria-describedby": this.getAriaDescribedBy(),
          onMouseEnter: shouldAddEventListeners ? () => this.setHoveredItemToState(item) : void 0,
          onMouseLeave: shouldAddEventListeners ? () => this.removeHoveredItemFromState() : void 0,
          "aria-required": this.props.inputType === "checkbox" ? this.props.required : void 0
        }
      ), renderIndicatorLabel());
    });
    return items;
  }
  getGridProps() {
    let align = [];
    let gutter = this.props.size === "large" ? "small" : "xsmall";
    if (this.props.align === "center") {
      align = ["center-xs"];
    } else if (this.props.align === "right") {
      align = ["end-xs"];
    }
    if (this.props.gutter) {
      gutter = this.props.gutter;
    }
    return {
      className: "selector__list",
      gutter,
      align,
      equalHeight: true,
      element: this.props.inputType === "checkbox" ? "ul" : void 0
    };
  }
  getItemLabel() {
    var _a;
    const itemValue = (_a = this.state.hoveredItemValue) != null ? _a : this.value;
    if (itemValue) {
      const selectedItem = this.props.items.find((item) => item.value === itemValue);
      return selectedItem == null ? void 0 : selectedItem.label;
    }
  }
  render() {
    const {
      align,
      className,
      employeeMessage,
      errorMessage,
      gutter,
      helpMessage,
      hideLabel,
      defaultValue,
      id,
      inputIntent,
      inputType,
      itemWidth,
      items,
      label,
      labelSize = "h6",
      onChange,
      onItemChange,
      required,
      size,
      showItemLabelNextToLabel,
      successMessage,
      theme,
      ...rest
    } = this.props;
    return /* @__PURE__ */ React.createElement(
      "fieldset",
      {
        className: this.BEM(),
        id,
        role: inputType === "radio" ? "radiogroup" : void 0,
        "aria-required": inputType === "radio" ? required : void 0,
        ...rest,
        "data-theme": theme,
        onClick: (e) => e.stopPropagation()
      },
      /* @__PURE__ */ React.createElement("legend", { className: "selector__label ".concat(labelSize) }, label, showItemLabelNextToLabel ? /* @__PURE__ */ React.createElement("span", { className: "text-bold" }, " ", this.getItemLabel()) : void 0),
      this.renderFormHelper(),
      /* @__PURE__ */ React.createElement(Grid, { ...this.getGridProps() }, this.mapItems())
    );
  }
};
_SelectorInner.defaultProps = {
  inputType: "radio",
  itemWidth: ["xs"]
};
let SelectorInner = _SelectorInner;
export {
  Selector,
  SelectorInner
};
